import React, { useState } from 'react'
import { DataTable, Button } from '@paypalcorp/pp-react'

interface ICellType {
  value: string[]
}

const CardBrandCell = ({ value }: { value: ICellType }) => {
  return (
    <>
      {value.map((brand: string, i: number) => (
        <span key={`cardbrand-${i}`}>
          {i === value.length - 1 ? (
            <span>{brand}</span>
          ) : (
            <>
              <span>{brand},</span>
              <br />
            </>
          )}
        </span>
      ))}
    </>
  )
}

const CurrenciesCell = ({ value }: { value: ICellType }) => {
  return (
    <>
      {value.map((cur: string, i: number) => {
        const isLast = i === value.length - 1
        const shouldAddLineBreak = (i + 1) % 8 === 0 && !isLast

        return (
          <>
            <code>{cur}</code>
            {isLast ? null : ','}
            {shouldAddLineBreak ? <br /> : null}
          </>
        )
      })}
    </>
  )
}

const allRows = [
  {
    id: 'row1',
    country: {
      value: 'Australia',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express (AUD only)'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row2',
    country: {
      value: 'Austria',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row3',
    country: {
      value: 'Belgium',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row4',
    country: {
      value: 'Bulgaria',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row5',
    country: {
      value: 'Canada',
    },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        'American Express (CAD only)',
        'JCB (CAD only)',
      ],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row6',
    country: {
      value: 'Cyprus',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row7',
    country: {
      value: 'Czech Republic',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row8',
    country: {
      value: 'Denmark',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row9',
    country: {
      value: 'Estonia',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row10',
    country: {
      value: 'Finland',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row11',
    country: {
      value: 'France',
    },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        'American Express',
        'Carte Bancaire (EUR only)',
      ],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row12',
    country: {
      value: 'Germany',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row13',
    country: {
      value: 'Greece',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row14',
    country: {
      value: 'Hungary',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row15',
    country: {
      value: 'Ireland',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row16',
    country: {
      value: 'Italy',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row17',
    country: {
      value: 'Japan',
    },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        'American Express (JPY only)',
        'JCB (JPY only)',
      ],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row18',
    country: {
      value: 'Latvia',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row19',
    country: {
      value: 'Liechtenstein',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row20',
    country: {
      value: 'Lithuania',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row21',
    country: {
      value: 'Luxembourg',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row22',
    country: {
      value: 'Malta',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row23',
    country: {
      value: 'Mexico',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: ['MXN'],
    },
  },
  {
    id: 'row24',
    country: {
      value: 'Netherlands',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row25',
    country: {
      value: 'Norway',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row26',
    country: {
      value: 'Poland',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row27',
    country: {
      value: 'Portugal',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row28',
    country: {
      value: 'Romania',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row29',
    country: {
      value: 'Slovakia',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row30',
    country: {
      value: 'Slovenia',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row31',
    country: {
      value: 'Spain',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row32',
    country: {
      value: 'Sweden',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row33',
    country: {
      value: 'United Kingdom',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: [
        'AUD',
        'BRL',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'ILS',
        'JPY',
        'MXN',
        'NOK',
        'NZD',
        'PHP',
        'PLN',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'USD',
      ],
    },
  },
  {
    id: 'row34',
    country: {
      value: 'United States',
    },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        'American Express (USD only)',
        'Discover (USD only)',
        'Debit networks (Star/Star Access, Pulse, Nyce, Accel)',
      ],
    },
    currencies: {
      value: ['AUD', 'CAD', 'EUR', 'GBP', 'JPY', 'USD'],
    },
  },
]

const columns = {
  country: {
    title: 'Country',
    width: '10%',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  cardBrand: {
    title: 'Card brand',
    cellAs: CardBrandCell,
    width: '15%',
    mobile: {
      placement: 'b3',
    },
  },
  currencies: {
    title: 'Currencies',
    cellAs: CurrenciesCell,
    width: '20%',
    mobile: {
      placement: 'b3',
    },
  },
}

const CurrencyCardBrandTable = () => {
  const [rows, setRows] = useState(allRows.slice(0, 5))
  const [isLoading, setLoading] = useState(false)
  const showSeeMoreBtn = rows.length < allRows.length

  const handleSeeMore = () => {
    setLoading(true)
    setTimeout(() => {
      setRows((currRowsShown) => allRows.slice(0, currRowsShown.length + 5))
      setLoading(false)
    }, 300)
  }

  return (
    <>
      <DataTable
        description="Basic"
        rows={rows}
        columns={columns}
        isLoading={isLoading}
        idPrefix="basic"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
      {showSeeMoreBtn && (
        <div className="table-btnWrapper">
          <Button onClick={handleSeeMore} size="sm" secondary>
            See more
          </Button>
        </div>
      )}
    </>
  )
}

export default CurrencyCardBrandTable
